import { ButtonBase, Card, CardContent, CardMedia, Divider, Typography, useMediaQuery } from '@mui/material';
import moment from 'moment';
import React from 'react'; 
import { useNavigate } from 'react-router-dom';
import { truncate } from '../../../utils/utils';
import LavaLoader from '../../Icons/LavaLoader/LavaLoader';
import Posts from '../Posts';
import styles from './styles'; 

const SuggestedPosts = ({posts}) => {

    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    // const openPost = (_id) => {
    //     console.log('post id: ', _id);
    //     navigate(`/posts/${_id}`);
    // }

    const openPost = (post) => {
        console.log('post id: ', post._id);
        navigate(`/posts/${post._id}`);
    }

    let suggestPostsStyle = isMobile ? 
        {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100vw'
        } 
        :{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%'
        }; 

    return (
        <div>
            {posts.length > 0 ? (
                <div style={styles.section}>

                    <Typography gutterBottom variant="h6" sx={{padding: '0px 20px'}}>
                        Suggested 
                    </Typography>

                    <Divider />

                    <div className='posts-container' style={{...suggestPostsStyle}}>

                        {/* {
                            posts.map(({title, message, name, likes, media, createdAt, _id})=>(
                                <Card className="card" sx={styles.postCard} key={_id}>

                                    <ButtonBase
                                        sx={styles.cardAction}
                                        onClick={()=>{openPost(_id)}}
                                    >

                                    
                                        <CardMedia style={styles.media} image={media[0]} title={title} variant="post" />
                                        <div style={styles.overlay}>

                                            <div>
                                                <Typography variant="h6">{name}</Typography>
                                                <Typography variant="body2">{ moment(createdAt).fromNow()}</Typography>
                                            </div>
                                            

                                            <div>
                                                <Typography
                                                    variant="h5"
                                                    gutterBottom
                                                >

                                                    {truncate(title, 50)}
                                                </Typography>

                                                <Typography
                                                    variant='body2'
                                                >

                                                    {truncate(message, 50)}
                                                </Typography>
                                            </div>
                                            
                                        </div>
                                    
                                    </ButtonBase>

                                </Card>
                            ))
                        } */}

                        <Posts posts={posts} onPostClick={openPost} />
                    </div>
                </div>
            ) : 

            <LavaLoader />
        
        }
        </div>
    ); 
}

export default SuggestedPosts; 